import { Component, Input } from "@angular/core";
import { ReportDesignItemGridValue } from "../../report-design-item";
import { bindFormGridProperty } from "../../report-designer/pipes/report-item-form-property-bind.pipe";

@Component({
  selector: "snt-report-form-renderer-grid",
  templateUrl: "report-form-renderer-grid.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportFormRendererGridComponent {
  @Input()
  item!: ReportDesignItemGridValue;

  @Input()
  dataSource!: Record<string, any>;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "table",
      config: {
        title: this.item.config.title,
        cols: this.item.config.cols,
        items: this.item.config?.items.map((item: any) => ({
          title: item.title,
          value: bindFormGridProperty(
            item.property,
            this.dataSource,
            item.dataType
          )
        }))
      }
    };
  }
}
